import { handlers as userHandlers } from "./handlers/users";
import { handlers as countryHandlers } from "./handlers/countries";
import { handlers as currencyHandlers } from "./handlers/currencies";
import { handlers as projectHandlers } from "./handlers/projects";
import { handlers as operationHandlers } from "./handlers/operations";
import { handlers as withdrawalApplicationHandlers } from "./handlers/withdrawalApplications";
import { handlers as messagingHandlers } from "./handlers/messaging";
import { handlers as fileUploadHandlers } from "./handlers/files";
import { handlers as stateHandlers } from "./handlers/states";

export const handlers = [
  ...userHandlers,
  ...countryHandlers,
  ...currencyHandlers,
  ...projectHandlers,
  ...operationHandlers,
  ...withdrawalApplicationHandlers,
  ...messagingHandlers,
  ...fileUploadHandlers,
  ...stateHandlers,
];
